// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Table from 'antd/lib/table';
import Tag from 'antd/lib/tag';
// COMPONENTS
import ActionMenu from './ActionMenu';
// APOLLO
import myQuestionsQuery from 'ApolloClient/Queries/myQuestions';
import { graphql } from 'react-apollo';

const columns = [
  {
    title: 'QUESTION',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'CATEGORIES',
    dataIndex: 'categories',
    render: (text, record) => (
      <div>
        {record.categories
            && record.categories.map(cat => (
              <Tag key={cat} className="mb1">
                {cat}
              </Tag>
            ))}
      </div>
    ),
  },
  {
    title: 'ACTIONS',
    width: 120,
    render: (text, record) => <ActionMenu record={record} />,
  },
];

export class CustomQuestionsTable extends React.Component {
  render = () => (
    <div style={{ marginTop: 10 }}>
      <Table
        rowKey={record => record._id}
        columns={columns}
        loading={this.props.myQuestionsQuery.loading}
        pagination={{
          defaultPageSize: 5,
        }}
        dataSource={this.props.myQuestionsQuery.myQuestions}
      />
    </div>
  );
}

export default graphql(myQuestionsQuery, { name: 'myQuestionsQuery' })(CustomQuestionsTable);



// WEBPACK FOOTER //
// ./src/routes/app-studio/QuestionTemplatesArea/CustomQuestionsTable/index.js